export const a = 'a'

export const stampShapes = ['Прямоугольный', 'Квадрат', 'Круг', 'Овал', 'Фигурный']
